// Copyright (c) 2016 Deere & Company

import sharedActions from '../shared/actions-list';

export default Object.freeze({
    CREATE_NEW_CUSTOMER_SUCCESS: 'CREATE_NEW_CUSTOMER_SUCCESS',
    READ_CUSTOMER_DETAILS_SUCCESS: 'READ_CUSTOMER_DETAILS_SUCCESS',
    READ_CUSTOMER_SEARCH_SUCCESS: 'READ_CUSTOMER_SEARCH_SUCCESS',
    RESET_CUSTOMER_DETAILS: 'RESET_CUSTOMER_DETAILS',
    UPDATE_CUSTOMERS_SUCCESS: 'UPDATE_CUSTOMERS_SUCCESS',
    UPDATE_CUSTOMER_DETAILS_SUCCESS: 'UPDATE_CUSTOMER_DETAILS_SUCCESS',
    ...sharedActions
});



// WEBPACK FOOTER //
// ./src/customer/actions-list.js